import { useSearchParams } from 'react-router-dom';

import Layout from '../components/layout/Layout';
import PageHeader from '../components/common/PageHeader';
import CategoriesTab from '../components/settings/CategoriesTab';
import CompanyProfileTab from '../components/settings/CompanyProfileTab';
import PasswordTab from '../components/settings/PasswordTab';
import UsersTab from '../components/settings/UsersTab';
import { useAuth } from '../contexts/AuthContext';

export default function SettingsPage() {
  const { hasPermission } = useAuth();
  const [params, setParams] = useSearchParams();

  const tabs = [
    hasPermission('company:view') && { id: 'company', label: 'Company Profile', icon: 'fa-building' },
    hasPermission('expenses:view') && { id: 'categories', label: 'Expense Categories', icon: 'fa-tags' },
    hasPermission('users:manage') && { id: 'users', label: 'Users', icon: 'fa-users-gear' },
    { id: 'password', label: 'Change Password', icon: 'fa-key' },
  ].filter(Boolean) as { id: string; label: string; icon: string }[];

  const requested = params.get('tab');
  const active = tabs.find((t) => t.id === requested)?.id ?? tabs[0].id;

  return (
    <Layout>
      <div className="max-w-5xl mx-auto">
        <PageHeader title="Settings" subtitle="Company details printed on invoices, categories, users and your password" />

        <div className="flex gap-1 overflow-x-auto border-b border-ink-200 mb-4 lg:mb-6">
          {tabs.map((t) => (
            <button
              key={t.id}
              onClick={() => setParams({ tab: t.id }, { replace: true })}
              className={`px-4 py-2.5 text-sm font-semibold whitespace-nowrap border-b-2 -mb-px transition-colors ${
                active === t.id ? 'border-brand-600 text-brand-700' : 'border-transparent text-ink-500 hover:text-ink-800'
              }`}
            >
              <i className={`fas ${t.icon} mr-2 text-xs`} />
              {t.label}
            </button>
          ))}
        </div>

        {active === 'company' && <CompanyProfileTab />}
        {active === 'categories' && <CategoriesTab />}
        {active === 'users' && <UsersTab />}
        {active === 'password' && <PasswordTab />}
      </div>
    </Layout>
  );
}
